import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {DialogModule} from "primeng/dialog";
import {ButtonDirective} from "primeng/button";
import {NgClass} from "@angular/common";
import {LocalService, SessionStorageService, SvgLoaderComponent} from "lib-base";
import {firstValueFrom, forkJoin} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {InstructivoComponent} from "../instructivo/instructivo.component";

@Component({
  selector: 'app-mensaje-inicial',
  standalone: true,
  imports: [
    DialogModule,
    ButtonDirective,
    NgClass,
    SvgLoaderComponent,
    InstructivoComponent
  ],
  template: `
    <p-dialog closable="true" [(visible)]="visible" (onHide)="onHide()" [draggable]="false"
              [breakpoints]="{'2000px': '630px', '1900px': '630px', '1700px': '630px',
               '1400px': '630px', '960px': '70vw', '640px': '90vw', '490px':'94vw'}"
              [modal]="true" [styleClass]="'alert'" [resizable]="false">
      <ng-template pTemplate="header">
        <header class="mb-4 flex justify-content-center align-items-center mx-auto">
          <h1 class="text-uppercase title font-23 ml-0 title-blue font-medium mt-3">{{ translations.title }}</h1>
        </header>
      </ng-template>
      <main class="container-modal-message">
        <div class="grid flex-column sm:flex-row">
          @for (item of cards; track item.id; let last = $last) {
            <section class="col flex flex-column align-items-center item-message p-3"
                     (mouseleave)="changeIconLeave($index)"
                     (mouseover)="changeIcon($index)"
                     [ngClass]="{'border-right-2 border-white': !last }">
              <div>
                <div class="flex justify-content-center align-items-center">
                  <svg-loader [name]="item.iconNormal" id="icon-ng-{{$index}}"  containerClass="icon-active" />
                  <svg-loader [name]="item.iconHover" id="icon-active-ng-{{$index}}" containerClass="icon-hover"/>
                </div>
                <h2
                  class="  text-center text-blue-general font-18 mb-2 font-medium text-uppercase">{{ item.title }}</h2>
                <p class="text-center app-text-gray font-14 line-height-3 mt-0 mb-5 ">{{ item.description }}</p>
              </div>
              <button class="border-round-3xl btn-shadow " pButton icon="pi pi-angle-right" [iconPos]="'right'"
                      [label]="item.buttonText" (click)="item.action()">
              </button>
            </section>
          }
        </div>

      </main>
    </p-dialog>

    <app-instructivo [visible]="showInstructivo"/>
  `,
  styleUrl: './mensaje-inicial.component.scss'
})
export class MensajeInicialComponent implements OnInit {
  visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  showInstructivo: boolean = false;
  translations: any = {};
  cards: any[] = [];
  private routePortal :string[] = ['/public/consulta/', '/public/consulta'];
  currentUrl: string = '';
  constructor(private router: Router, private _t: TranslateService, private activate: ActivatedRoute, private _ls: LocalService) {
    this.currentUrl  = this.router.url?.replace(this.activate.snapshot.params['text'],'');
  }

  ngOnInit(): void {
    this.initTranslations().then(() =>
      this.initCards()
    );
  }

  private initCards() {
    this.cards = [
      {
        id:1,
        iconNormal: 'ico-tramite-normal',
        iconHover: 'ico-tramite-gradient',
        title: this.translations.tituloTramite,
        description: this.translations.descripcionTramite,
        buttonText: this.translations.btnTramite,
        action: () => {
          this.visible = false;
          if (!this.routePortal.includes(this.currentUrl )) {
            this.router.navigate([this.routePortal[0]]);
          }
          this.showInstructivo = this.showInstructivoSession;
        }
      }, {
        id:2,
        iconNormal: 'ico-pqrsdf-normal',
        iconHover: 'ico-pqrsdf-gradient',
        title: this.translations.tituloPQRSDF,
        description: this.translations.descripcionPQRSDF,
        buttonText: this.translations.btnPQRSDF,
        action: () => {
          this.visible = false;
          if (this.currentUrl !== '/pqrsdf')
            this.router.navigate(['/pqrsdf']);
        }
      },
    ]
  }

  async initTranslations(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      title: this._t.get('components.app-mensaje-inicial.title'),
      tituloTramite: this._t.get('components.app-mensaje-inicial.titulo-tramite'),
      descripcionTramite: this._t.get('components.app-mensaje-inicial.descripcion-tramite'),
      btnTramite: this._t.get('components.app-mensaje-inicial.btn-tramite'),
      tituloPQRSDF: this._t.get('components.app-mensaje-inicial.titulo-pqrsdf'),
      descripcionPQRSDF: this._t.get('components.app-mensaje-inicial.descripcion-pqrsdf'),
      btnPQRSDF:this._t.get('components.app-mensaje-inicial.btn-pqrsdf'),
    }));
  }

  show() {
    this.visible = true;
  }

  onHide() {
    if (this.visible) this.visible = false;
    this.visibleChange.emit(this.visible);
    if (this.routePortal.includes(this.currentUrl))
      this.showInstructivo = this.showInstructivoSession;
  }

  get showInstructivoSession(): boolean {
    return this._ls.showInstructivo;
  }


  changeIcon(idx: number) {
    const item = this.cards[idx];
    item.over = true;
  }

  changeIconLeave(idx:number) {
    const item= this.cards[idx];
    item.over = false;
  }
}
